import React, { Fragment } from 'react';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { getReportsCategoriesList, selectReportRequest } from './../ReportsPage/action';
import { connect } from 'react-redux';
import { Page, Separator, Box } from './../../components/containers';
import { Headline, ErrorBox } from '../../components/text';
import { LoadingSpinner } from '../../components/loaders';
import {
    getIsReportsListOpen,
    getIsReportsListLoading,
    getHasReportsListFetchFailed,
    getReportsList,
    getReportsListLastFetchTimestamp,
} from './../../selectors';
import s from './index.css';

const mapStateToProps = state => ({
    loading: getIsReportsListLoading(state),
    error: getHasReportsListFetchFailed(state),
    data: getReportsList(state),
    lastFetchTimestamp: getReportsListLastFetchTimestamp(state),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    getReportsCategoriesList: bindActionCreators(getReportsCategoriesList, dispatch),
    selectReportRequest: bindActionCreators(selectReportRequest, dispatch),
});

class RequestReportsListPage extends React.Component {
    componentDidMount() {
        this.props.getReportsCategoriesList();
    }

    render() {
        const { loading, error, data, lastFetchTimestamp } = this.props;

        return (
            <Page>
                <div className={s.wrapper}>
                    <Headline className={s.label} size="small">
                        Pick report type to create
                    </Headline>

                    <Separator type="narrow" />

                    {error && (
                        <ErrorBox
                            onClick={this.handleRefetch}
                            label="Could not load available reports, click here to try again"
                        />
                    )}

                    {lastFetchTimestamp > 0 && data.length <= 0 && (
                        <ErrorBox label="You have no active permissions to create any of current reports" />
                    )}

                    <div className={s.boxes}>
                        {(loading || typeof data === 'undefined') && (
                            <Box className={classNames(s.box, s.loadingBox)}>
                                <LoadingSpinner size={64} />
                            </Box>
                        )}

                        {data.map(reportType => (
                            <Box key={reportType.reportId} className={classNames(s.box, s.reportBox)}>
                                <button onClick={this.handleSelectReport(reportType)}>
                                    <p>{reportType.repTitle}</p>
                                </button>
                            </Box>
                        ))}
                    </div>
                </div>
            </Page>
        );
    }

    handleRefetch = e => {
        this.props.getReportsCategoriesList();
    };

    handleSelectReport = reportType => e => {
        e.preventDefault();
        this.props.selectReportRequest(reportType.reportId, reportType.repTitle);
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestReportsListPage);



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportsListPage/index.jsx